import { render, staticRenderFns } from "./AddLocationSubmit.vue?vue&type=template&id=3a11f176&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationSubmit.vue"
export default component.exports